<template>
  <div class="map">
    <div class="search-box">
      <input
        ref="autocomplete"
        placeholder="Search Hotel / Place"
        class="form-control rounded"
        onfocus="value = ''"
        type="text"
      />
      <i class="bx bx-search-alt search-icon text-secondary" />
    </div>
  </div>
</template>
<script>
export default {
  name: "Map",
  mounted() {
    /*global google*/
    this.autocomplete = new google.maps.places.Autocomplete(
      this.$refs.autocomplete,
      {
        fields: [
          "address_components",
          "international_phone_number",
          "formatted_address",
          "geometry",
          "name",
          "url",
          "website",
          "place_id",
          "rating",
          "icon",
        ],
        strictBounds: false,
      }
    );
    this.autocomplete.addListener("place_changed", () => {
      const place = this.autocomplete.getPlace();
      this.$emit("update:place", place);
    });
  },
};
</script>

<style>
.wizard-form-input,
.wizard-form-input input {
  font-size: 18px;
  min-height: 50px;
}
.search-box .wizard-form-input {
  padding-left: 40px;
}
.pac-container {
  z-index: 10011;
}
</style>
